import React from "react";
import NoRecord from "../../components/other/NoRecord";

const Listing = ({ contentData = [], color = "#d78c2e" }) => {
  const getSectionStyles = (index) => {
    return {
      backgroundColor: index % 2 === 0 ? color : "", // alternating background color
      color: index % 2 === 0 ? "white" : "black", // alternating text color
    };
  };

  return (
    <>
      <div className="untree_co-section product-section py-5 my-4">
        <div className="container">
          {contentData && contentData?.length > 0 ? (
            contentData?.map((content, index) => (
              <div
                className="row align-items-center my-4 ct_section_bg_brown"
                key={index}
                style={getSectionStyles(index)} // Apply dynamic styles here
              >
                {index % 2 === 0 ? (
                  <>
                    <div className="col-lg-5 mb-4 mb-md-0">
                      <div className="ct_img_cover">
                        <img
                          src={content?.image}
                          alt=""
                          className="ukiyo"
                          onDragStart={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 offset-lg-1 mb-4 mb-md-0">
                      <div className="ct_section_cnt12">
                        <h4 className="ct_fs_28">{content?.title}</h4>
                        <div
                          className="ct_event_h_scroll_1"
                          dangerouslySetInnerHTML={{ __html: content?.text }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-lg-6 mb-4 mb-md-0">
                      <div className="ct_section_cnt12">
                        <h4 className="ct_fs_28">{content?.title}</h4>
                        <div
                          className="ct_event_h_scroll_1"
                          dangerouslySetInnerHTML={{ __html: content?.text }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-5 mb-4 mb-md-0 offset-lg-1">
                      <div className="ct_img_cover">
                        <img src={content?.image} alt="" className="ukiyo" />
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))
          ) : (
            <NoRecord />
          )}
        </div>
      </div>
    </>
  );
};

export default Listing;
